<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 2C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H19ZM4 17V19C4 19.5523 4.44772 20 5 20H6V17H4ZM16 13H8V20H16V13ZM20 17H18V20H19C19.5523 20 20 19.5523 20 19V17ZM20 9H18V15H20V9ZM16 4H8V11H16V4ZM19 4H18V7H20V5C20 4.44772 19.5523 4 19 4ZM6 4H5C4.44772 4 4 4.44772 4 5V7H6V4ZM4 15H6V9H4V15Z"
    fill="currentColor"
  />
</svg>
